import AcihwManifestApiUrls from 'src/apiUrls/AciHighwayManifestApiUrls'
import FormProperties from './FormProperties'
import { Grid } from '@material-ui/core'
import React, { useEffect, useRef, useState } from 'react'
import { components } from 'cng-web-lib'
import pathMap from 'src/paths/pathMap'
import { useLocation } from 'react-router-dom'
import ConfirmDialog from 'src/views/common/ConfirmDialog'
import ACIHighwayManifestTranslationText from './../contexts/ACIHighwayManifestTranslationText'

const {
  button: { CngButton },
  form: { CngAddForm }
} = components

function ManifestAddPage({ history, showNotification, onSetLoading }) {
  const loc = useLocation()
  const aciHighwayManifestTranslationText = ACIHighwayManifestTranslationText()
  const onSuccessCallback = useRef((e) =>
    history.push(`${pathMap.ACIHWY_MANIFEST}/edit/` + e.id)
  )
  let formikPropsData;
  if (loc.state !== undefined && loc.state.shouldRerender === undefined) {
    formikPropsData = {
      ...FormProperties.formikProps,
      initialValues: loc.state,
    }
  } else {
    formikPropsData = FormProperties.formikProps
  }

  function handleSaveAndContinue() {
    onSuccessCallback.current = (e) => {
      history.push({
        pathname: `${pathMap.ACIHWY_MANIFEST}/edit/` + e.id,
        state: { step: 2, manifestData: e }
      })
    }
  }

  return (
    <CngAddForm
      fieldLevel="toBeChangedByDeveloperIfWantFieldLevelRestriction"
      history={history}
      showNotification={showNotification} 
      renderBodySection={(labelMap, shouldHideMap, shouldDisableMap) => (
        <FormProperties.Fields
          disabled={false}
          showNotification={showNotification}
          shouldHideMap={shouldHideMap}
        />
      )}
      formikProps={formikPropsData}
      toClientDataFormat={FormProperties.toClientDataFormat}
      toServerDataFormat={FormProperties.toServerDataFormat}
      create={{
        url: AcihwManifestApiUrls.POST,
        onSuccess: (e) => {
          showNotification('success', aciHighwayManifestTranslationText.recordAddSuccess)
          onSuccessCallback.current(e)
          onSetLoading(false)
        }
      }}
      renderButtonSection={(loading) => (
        <ManifestAddPageButtonSection
          history={history}
          loading={loading}
          onSaveAndContinue={handleSaveAndContinue}
          onSetLoading={onSetLoading}
        />
      )}
    />
  )
}

export default ManifestAddPage

function ManifestAddPageButtonSection(props) {
  const { history, loading, onSaveAndContinue, onSetLoading } = props

  const [confirmDialog, setConfirmDialog] = useState(false)

  const aciHighwayManifestTranslationText = ACIHighwayManifestTranslationText()

  useEffect(() => {
    onSetLoading(loading)
  }, [loading])

  return (
    <>
      <Grid container justify='space-between' spacing={3}>
        <Grid item xs='auto'>
          <CngButton
            color='secondary'
            disabled={loading}
            onClick={() => setConfirmDialog(true)}
            size='medium'
          >
            {aciHighwayManifestTranslationText.discardButton}
          </CngButton>
        </Grid>
        <Grid item xs='auto'>
          <Grid container spacing={2}>
            <Grid item xs='auto'>
              <CngButton
                color='primary'
                disabled={loading}
                // onClick={onSaveOnly}
                type='submit'
                size='medium'
                shouldShowProgress={loading}
              >
                {aciHighwayManifestTranslationText.saveButton}
              </CngButton>
            </Grid>
            <Grid item xs='auto'>
              <CngButton
                color='primary'
                disabled={loading}
                type='submit'
                onClick={onSaveAndContinue}
                size='medium'
              >
                {aciHighwayManifestTranslationText.saveAndContinueButton}
              </CngButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <ConfirmDialog
        isConfirmDialogOpen={confirmDialog}
        closeDialog={() => setConfirmDialog(false)}
        confirmDialog={() => history.push(pathMap.ACIHWY_MANIFEST_LIST_VIEW)}
        content={aciHighwayManifestTranslationText.addDiscardConfirmMsg}
        okMsg={aciHighwayManifestTranslationText.addDiscardProceedMsg}
        cancelMsg={aciHighwayManifestTranslationText.addDiscardCancelMsg}
        title={aciHighwayManifestTranslationText.discardTitle}
      />
    </>
  )
}
